export default __webpack_public_path__ + "static/alj-saudi-arabia-84f4db84f357a6bbcdb5037ba67b59bc.mp4";